import { render, staticRenderFns } from "./IngredientCrud.vue?vue&type=template&id=24585208&"
import script from "./IngredientCrud.vue?vue&type=script&lang=js&"
export * from "./IngredientCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports